export const createScheduler = () => {
    // 任务 id
    let taskId;
    // 执行调度的回调函数
    let callback;
    // 即将调度的时间
    let scheduleTime = -Infinity;
    const getCurrentTime = () => {
        return performance.now();
    };
    function noop() {
        // No operation performed.
    }
    const clearCurrentScheduleTimer = () => {
        window.clearTimeout(taskId);
    };
    const resetScheduler = (newScheduleTime) => {
        if (!callback) {
            return;
        }
        // 新配置的时间早于即将调度的时间，不处理
        if (newScheduleTime < scheduleTime) {
            return;
        }
        clearCurrentScheduleTimer();
        const newTime = newScheduleTime - getCurrentTime();
        taskId = window.setTimeout(() => {
            callback();
        }, newTime);
        scheduleTime = newScheduleTime;
    };
    const startSchedule = (cb, time) => {
        callback = cb;
        resetScheduler(time);
    };
    const stopSchedule = () => {
        clearCurrentScheduleTimer();
        callback = noop;
    };
    return {
        resetScheduler,
        startSchedule,
        stopSchedule,
    };
};
